import { FilterFieldType, FilterOperator } from './filterTypes'

export function getOperatorsForType(type: FilterFieldType): FilterOperator[] {
  switch (type) {
    case 'text':
      return ['contains', 'equals', 'starts_with', 'ends_with']
    case 'choice':
      return ['equals']
    case 'user':
      return ['equals', 'not_equal']
    case 'number':
    case 'size':
      return ['greater_than', 'less_than']
    case 'date':
      return ['before', 'after']
    default:
      return ['equals']
  }
}

export function generateFilterId(): string {
  return `filter_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
}
